export default function TwitterLink() {
    return <a href="https://twitter.com/PnrPOKER" className="underline">Twitter</a>
}